<template>
  <el-dialog v-dialogDrag :title="dialogDragTitle" custom-class="daoru-dialog" :visible.sync="batchImportDialogVisible"
    :close-on-click-modal="false" :close-on-press-escape="false" width="600px" :before-close="handlePofessionClose">
    <span>
      <div v-if="!fileList.length" style="height:32px;line-height:32px">
        <p style="float: left;">请下载导入模板，按格式修改后导入</p>
        <el-button style="float: right;" size="small" type="primary" @click="down">
          模板下载
        </el-button>
      </div>
      <div v-if="!fileList.length">
        <div style="text-align: center;margin-top: 15px;">
          <el-upload drag action="/" :before-upload="dataprogress" :show-file-list="false"
            :http-request="httpRequest" :accept="accept">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖拽至此区域，或<em>点击上传</em>
            </div>
            <div v-if="needType===1||needType===3" slot="tip" class="el-upload__tip">
              仅支持xls、xlsx格式，文件大小不超过5M
            </div>
            <div v-else slot="tip" class="el-upload__tip">
              仅支持xlsx格式，文件大小不超过5M
            </div>
          </el-upload>
        </div>
      </div>
      <div v-if="fileList.length && isfail == 2">
        <div
          style="text-align:center;border: 1px dashed #d9d9d9;border-radius:6px;width: 360px;margin: 0 auto;padding: 50px 0px;">
          <img :src="xlssrc" alt="" style="vertical-align: text-bottom;" />
          <p>
            <span>{{ fileList[0].name }}</span>
          </p>
        </div>
        <div style="text-align:center;margin-top:20px">
          <el-button size="small" type="primary" plain :loading="disabledone" @click="newuplode">
            重新上传
          </el-button>
          <el-button size="small" type="primary" :loading="disabledone" @click="suredaoru">
            确认导入
          </el-button>
        </div>
      </div>
      <div v-if="fileList.length && isfail == 1">
        <div style="text-align:center;">
          <img :src="dangersrc" alt="" />
        </div>
        <p style="text-align:center;margin-top:20px;font-size:16px">
          <span style="color:var(--theme-color)">{{ successtotals }}</span>条导入成功， <span
            style="color:#E6A23C">{{ dangertotals }}</span>条导入失败
          <span style="color:var(--theme-color);cursor: pointer;" @click="getList(dangerlist)">下载失败列表</span>
        </p>
        <div style="text-align:center;margin-top:20px">
          <el-button size="small" type="primary" plain @click="newuplode">
            重新导入
          </el-button>
        </div>
      </div>
      <div v-if="fileList.length && isfail == 0">
        <div style="text-align:center">
          <img :src="successsrc" alt="" />
        </div>
        <p style="text-align:center;margin-top:20px;font-size:16px">
          <span style="color:var(--theme-color)">{{ successtotals }}</span>条导入成功
        </p>
        <div style="text-align:center;margin-top:20px">
          <el-button size="small" type="primary" plain @click="newuplode">
            继续导入
          </el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogDragTitle: {
      type: String,
      default: '批量邀请'
    },
    accept: {
      type: String,
      default: '.xlsx,.xls'
    },
    needType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      batchImportDialogVisible: false,
      xlssrc: require("@/CommonDP/assets/addpersonInfo/图表.png"),
      successsrc: require("@/CommonDP/assets/addpersonInfo/导入成功.png"),
      dangersrc: require("@/CommonDP/assets/addpersonInfo/导入失败.png"),
      fileList: [], // 上传的文件      有文件 就展示文件列表页面 没文件就展示选择文件的页面
      disabledone: false, // 正在调用上传文件的接口
      dangerlist: [], // 失败的文件
      successtotals: 0, // 成功的条数
      dangertotals: 0, // 失败的条数
      isfail: 2 // 1 展示失败 0展示成功 2展示文件列表页
    };
  },
  methods: {
    // 关闭驳回弹框
    handlePofessionClose() {
      this.batchImportDialogVisible = false;
    },
    // 上传1
    dataprogress(file) {
      var tt = file.name;
      var ttt = tt.split(".");
      var ttl = ttt.length;
      const isXLSX = ttt[ttl - 1] === "xlsx";
      const isXLS = ttt[ttl - 1] === "xls";
      const isPG = isXLSX || isXLS;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if ((this.needType === 1 || this.needType === 3) && !isPG) {
        this.$message({
          showClose: true,
          message: "上传文件只能是 .xls .xlsx 格式!",
          type: "warning"
        });
      } else if (this.needType === 2 && !isXLSX) {
        this.$message({
          showClose: true,
          message: "上传文件只能是 .xlsx 格式!",
          type: "warning"
        });
      } else if (!isLt2M) {
        this.$message({
          showClose: true,
          message: "上传文件大小不能超过 5M!",
          type: "warning"
        });
      }
      return isPG && isLt2M;
    },
    // 上传2
    async httpRequest({ file }) {
      this.fileList.push(file);
    },
    newuplode() {
      this.disabledone = false;
      this.fileList = [];
      this.dangerlist = [];
      this.isfail = 2;
    },
    suredaoru() {
      this.$emit('suredaoru', this.fileList[0]);
    },

    async getList(failList) {
      this.$emit('getList', failList);
    },
    commonSuredaoru(res1) {
      if (res1.result === "0") {
        this.disabledone = false;
        if (res1.data.failList.length) {
          // 导入失败
          if (this.needType === 1) {
            this.successtotals = res1.data.total - res1.data.failList.length; // 成功条数
            this.dangertotals = res1.data.failList.length; // 失败条数
            this.dangerlist = res1.data.failList;
          } else {
            this.successtotals = res1.data.successNum; // 成功条数
            this.dangertotals = res1.data.failList.length; // 失败条数
            this.dangerlist = res1.data.failList;
          }
          this.isfail = 1;
        } else {
          // 导入成功
          this.dangerlist = [];
          this.successtotals = this.needType === 1 ? res1.data.total : res1.data.successNum;
          this.isfail = 0;
          this.$emit('getfreshen');
        }
      }
    },
    commonGetList(response) {
      const fileName = "导入失败列表.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        // 兼容ie
        window.navigator.msSaveOrOpenBlob(response, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = response;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    down() {
      this.$emit('downTemplate');
    }
  }
};
</script>

<style lang="scss" scoped>
.daoru-dialog {
  border-radius: 5px;
  .el-dialog__body {
    padding: 20px;
    border-top: 1px solid #2e5bff1a;
    border-bottom: 1px solid #2e5bff1a;
    .el-radio {
      height: 25px;
    }
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-upload-dragger {
      margin: 0 auto;
    }
  }
  .el-table__empty-text {
    line-height: 30px;
  }
  .el-textarea__inner {
    height: 200px;
  }
}
</style>
